/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Glad_Cool_Grebe_CareInputs */

const fr_glad_cool_grebe_care = /** @type {(inputs: Glad_Cool_Grebe_CareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune vidéo renseignée`)
};

/**

* @param {Glad_Cool_Grebe_CareInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const glad_cool_grebe_care = /** @type {((inputs?: Glad_Cool_Grebe_CareInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Glad_Cool_Grebe_CareInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_glad_cool_grebe_care(inputs)
});